import { render, staticRenderFns } from "./MerchantRegistrationForm.vue?vue&type=template&id=72dac5e8&scoped=true&"
import script from "./MerchantRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./MerchantRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./MerchantRegistrationForm.vue?vue&type=style&index=0&id=72dac5e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dac5e8",
  null
  
)

export default component.exports